<template>
    <div class="m-3">
        <h2 class="font-bold mb-3">Дякуємо за відповідь! Вона буде опублікована після успішної модерації 🙌</h2>
    </div>
</template>
